import { render, staticRenderFns } from "./ProductDistributionCell.vue?vue&type=template&id=7c4d7616&scoped=true&"
import script from "./ProductDistributionCell.vue?vue&type=script&lang=js&"
export * from "./ProductDistributionCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4d7616",
  null
  
)

export default component.exports